// DATAGRID
export const localeText = {
    // Menu
    columnMenuLabel: 'Menu', // Texto do botão do menu (se visível)
    columnMenuShowColumns: 'Mostrar/Ocultar Colunas',
    columnMenuFilter: 'Filtrar',
    columnMenuHideColumn: 'Ocultar Coluna',
    columnMenuSortAsc: 'Ordenar Ascendente',
    columnMenuSortDesc: 'Ordenar Descendente',

    // Para filtros de texto
    filterPanelInputLabel: 'Filtrar valor',
    filterPanelColumns: 'Colunas',
    filterPanelOperators: 'Operadores',
    filterOperatorContains: 'Contém',
    filterOperatorEquals: 'É igual a',
    filterOperatorStartsWith: 'Começa com',
    filterOperatorEndsWith: 'Termina com',
    filterOperatorIsEmpty: 'É vazio',
    filterOperatorIsNotEmpty: 'Não é vazio',

    // Para filtros numéricos
    filterOperatorGreaterThan: 'É maior que',
    filterOperatorGreaterThanOrEqual: 'É maior ou igual a',
    filterOperatorLessThan: 'É menor que',
    filterOperatorLessThanOrEqual: 'É menor ou igual a',
    filterOperatorIs: 'É',
    filterOperatorIsNot: 'Não é',

    // Botões do painel de filtro
    filterPanelAddFilter: 'Adicionar filtro',
    filterPanelDeleteIconLabel: 'Excluir',
    filterPanelLinkOperator: 'Operador lógico',
    filterPanelLogicAnd: 'E',
    filterPanelLogicOr: 'OU',
    filterPanelInputPlaceholder: 'Valor',

    // Outros textos relacionados à filtragem (se houver)
    columnHeaderFiltersLabel: 'Filtrar',
    columnHeaderSortIconLabel: 'Ordenar',
    toolbarFilters: 'Filtros',
    toolbarDensity: 'Densidade',
    toolbarExport: 'Exportar',

    // Footer
    paginationLabelRowsPerPage: 'Itens por página'
};

export const formatValor = (value) => {
    // 1. Converte a string para um número float
    const numericValue = parseFloat(value);

    // 2. Verifica se a conversão resultou em um número válido
    if (isNaN(numericValue)) {
        console.warn(`Tentativa de formatar um valor não numérico: ${value}`);
        return ''; // Retorna string vazia ou um valor padrão para inválidos
    }

    if (numericValue === 0) {
        return 'Consulte';
    }

    // 3. Formata o número como moeda brasileira
    // 'pt-BR' para localização brasileira
    // 'currency' para estilo de moeda
    // 'BRL' para o código da moeda brasileira (Real)
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2, // Garante que sempre terá 2 casas decimais
        maximumFractionDigits: 2, // Garante que sempre terá 2 casas decimais
    }).format(numericValue);
};

export const formatKm = (value) => {
    let km = value.toString();

    if (km === '0') {
        return 'Consulte';
    }

    if (km.length === 7) {
        const a = km.slice(0, 1);
        const b = km.slice(1, 4);
        const c = km.slice(4, km.length + 1);
        km = a.concat(".", b, ".", c);
    }

    if (km.length === 6) {
        const a = km.slice(0, 3);
        const b = km.slice(3, km.length + 1);
        km = a.concat(".", b);
    }

    if (km.length === 5) {
        const a = km.slice(0, 2);
        const b = km.slice(2, km.length + 1);
        km = a.concat(".", b);
    }
    return km + " km";
}